<template>
    <span>
        <svg-icon :width="width" :height="height" :viewBox="`0 0 ${height} ${width}`" iconName="shutter">
            <defs>
                <path id="fabrv47owa" d="M17.657 6.343C16.146 4.833 14.137 4 12 4s-4.146.832-5.657 2.343C4.833 7.854 4 9.863 4 12s.832 4.146 2.343 5.657C7.854 19.167 9.863 20 12 20s4.146-.832 5.657-2.343C19.167 16.146 20 14.137 20 12s-.832-4.146-2.343-5.657zM12 18.707c-3.698 0-6.707-3.009-6.707-6.707S8.302 5.293 12 5.293 18.707 8.302 18.707 12 15.698 18.707 12 18.707zm6.48-2.662l-4.222-7.31c-.178-.309-.573-.415-.883-.236-.309.178-.415.574-.236.883l4.221 7.31c.12.207.337.323.56.323.11 0 .221-.028.323-.087.309-.179.415-.574.236-.883zm.263-7.633h-8.442c-.357 0-.646.29-.646.647 0 .356.29.646.646.646h8.442c.357 0 .647-.29.647-.646 0-.357-.29-.647-.647-.647zm-5.596-4.281c-.31-.179-.705-.073-.883.236l-4.221 7.31c-.179.309-.073.704.236.883.102.058.213.086.323.086.223 0 .44-.115.56-.323l4.221-7.31c.179-.308.073-.704-.236-.882zM10.86 14.618L6.64 7.308c-.179-.308-.574-.414-.883-.236-.31.179-.415.574-.236.883l4.22 7.31c.12.207.338.323.56.323.11 0 .222-.028.323-.087.31-.178.415-.574.237-.883zm2.838-.323H5.257c-.357 0-.647.29-.647.646 0 .357.29.647.647.647h8.442c.357 0 .646-.29.646-.647 0-.357-.29-.646-.646-.646zm2.022-2.855c-.31-.178-.705-.072-.883.237l-4.221 7.31c-.179.308-.073.704.236.882.102.06.213.087.323.087.223 0 .44-.116.56-.323l4.221-7.31c.179-.309.073-.704-.236-.883z"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <mask id="53cih8kqib" fill="#fff">
                    <use xlink:href="#fabrv47owa"/>
                </mask>
                <g class="path" :fill="fill" mask="url(#53cih8kqib)">
                    <path :d="`M0 0H${height}V${width}H0z`"/>
                </g>
            </g>
        </svg-icon>
    </span>
</template>

<script>
import SvgIcon from '@theme-views/common/SvgIcon'

export default {
    name: 'svg-shutter',
    computed: {
        fill() {
            return this.color || 'url(#linearGradient-1)'
        }
    },
    components: {
        SvgIcon
    },
    props: {
        width: {
            type: Number,
            default: 26,
        },
        height: {
            type: Number,
            default: 26,
        },
        color: {
            type: String,
            default: null
        }
    },
}
</script>